/**
 * Infrastructure Configuration
 * Configuración para el sistema de traducciones
 */
export interface TranslationConfig {
  readonly defaultLanguage: string;
  readonly supportedLanguages: string[];
  readonly fallbackLanguage: string;
  readonly translationPath: string;
}

export const TRANSLATION_CONFIG: TranslationConfig = {
  defaultLanguage: 'es',
  supportedLanguages: ['es', 'en'],
  fallbackLanguage: 'es',
  translationPath: '/assets/i18n'
};
